import { Box, Card, Divider, Group, rem, SimpleGrid, Space, Stack, Text, ThemeIcon } from "@mantine/core"
import { IconCalculator, IconCalendarRepeat, IconCalendarWeek, IconMoneybag, IconProps } from "@tabler/icons-react"
import { colors, products } from "../../data"
import { AnimatedWrapper, footer, mainHeader } from "../Common/Renders"
import { IProduct } from "../Home/Props"

export function multiLineEntryWithIcon(
  index: number,
  title: string,
  subtitle: string,
  Icon: React.FC<IconProps>
): React.ReactElement {
  return (
    <Group gap={rem(24)} justify="flex-start">
      <ThemeIcon variant="light" size={rem(32)} radius={rem(16)} color={colors[index % colors.length]}>
        <Icon size={24} stroke={1.5} />
      </ThemeIcon>

      <Stack gap={rem(4)} align="flex-start">
        <Text size={rem(16)} fw={600}>
          {title}
        </Text>
        <Text size={rem(14)} opacity={0.75}>
          {subtitle}
        </Text>
      </Stack>
    </Group>
  )
}

function productCard(index: number, product: IProduct): React.ReactElement {
  return (
    <AnimatedWrapper index={index} y={50}>
      <Card
        withBorder
        shadow="sm"
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column"
        }}
      >
        <Stack gap={rem(16)}>
          <Text size={rem(20)} fw={600}>
            {product.name}
          </Text>

          <Divider variant="solid" />

          <Text size={rem(16)} opacity={0.85}>
            {product.description}
          </Text>

          <Space h={rem(8)} />

          <SimpleGrid cols={{ base: 1, sm: 2 }}>
            {multiLineEntryWithIcon(1, "Amount", product.amount, IconMoneybag)}
            {multiLineEntryWithIcon(2, "Rate", product.rate, IconCalculator)}
            {multiLineEntryWithIcon(3, "Term", product.term, IconCalendarWeek)}
            {multiLineEntryWithIcon(4, "Frequency", product.frequency, IconCalendarRepeat)}
          </SimpleGrid>
        </Stack>
        <Space h={rem(8)} />
      </Card>
    </AnimatedWrapper>
  )
}

export function Products(): React.ReactElement {
  return (
    <Box p={"md"}>
      {mainHeader()}

      <Space h={rem(32)} />

      <Group mb={rem(32)}>
        <Text size={rem(32)} fw={700}>
          Our Products
        </Text>
      </Group>

      <SimpleGrid cols={{ base: 1, sm: 2 }} spacing={rem(32)}>
        {products.map((product, index) => productCard(index, product))}
      </SimpleGrid>

      <Space h={rem(48)} />

      {footer()}
    </Box>
  )
}
